import React, { Component } from "react"
import { setupBraintree, saveCC } from "../../shared_component/utils/setupBraintree"
import { connect } from "react-redux"
import { storeUser, setLoading, setNotLoading } from "../actions/user"
import { getPaymentMethods } from "../actions/paymentMethods"
import LoadingComponent from "../components/LoadingComponent"

class Braintree extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  async setupData() {
    await this.setState({ loadingBT: true })
    let btInstance = await setupBraintree({
      authentication_token: this.props.user.authentication_token,
      div: "#payment-form"
    })
    if (btInstance) await this.setState({ braintreeInstance: btInstance })
    this.setState({ loadingBT: false })
  }

  componentDidUpdate(nextProps, nextState) {
    if (this.props.isLoggedIn && this.props.alwaysShowForm && !this.state.braintreeInstance)
      this.setupData()
  }

  componentDidMount(nextProps, nextState) {
    if (this.props.isLoggedIn && this.props.alwaysShowForm && !this.state.braintreeInstance)
      this.setupData()
  }

  renderBTElement() {
    return (
      <div>
        {this.state.loadingBT && <LoadingComponent />}
        <div style={this.state.loadingBT ? { display: "none" } : {}}>
          <div id="payment-form" className="noApprovalServiceName"></div>
        </div>
      </div>
    )
  }

  render() {
    let childWithProps = React.cloneElement(this.props.children, {
      saveCC: saveCC.bind(this, {
        authentication_token: this.props.user.authentication_token,
        user: this.props.user,
        instance: this.state.braintreeInstance,
        storeUser: this.props.storeUser,
        getPaymentMethods: this.props.getPaymentMethods
      }),
      renderBTElement: this.renderBTElement.bind(this),
      activateBTElement: this.setupData.bind(this),
      ...this.props
    })
    return childWithProps
  }
}

function mapStateToProps(state) {
  let user = state.user || {}
  return {
    user,
    isLoggedIn: !!user.authentication_token
  }
}

export default connect(mapStateToProps, {
  storeUser,
  setLoading,
  setNotLoading,
  getPaymentMethods
})(Braintree)
